import React from "react";
import Button from "../components/ui/button/button";
import "../components/layout/error/error.css";
import Header from "../components/layout/header/Header";
import Footer from "../components/layout/footer/Footer";
import { useLocation, useNavigate } from "react-router-dom";


const getDisplayCode = (code?: string) => {
  switch (code) {
    case "VALIDATION_ERROR":
      return "400";

    case "NOT_FOUND":
      return "404";

    case "AUDIT_ALREADY_CLAIMED":
      return "409";

    case "FETCH_BLOCKED":
      return "403";

    case "FETCH_UNREACHABLE":
      return "502";

    case "AUDIT_TIMEOUT":
      return "408";

    case "NETWORK_ERROR":
      return "503";

    case "AUDIT_ERROR":
      return "500";

    default:
      return code || "500";
  }
};

const ErrorPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const {
    code,
    title = "Something went wrong",
    message = "An unexpected error occurred.",
    auditType,
    auditData,
  } = location.state || {};

  const handleRetry = () => {
    navigate(`/audit?type=${auditType}`, {
      state: {
        retryData: auditData,
      },
    });
  };

  const handleEdit = () => {
    navigate(`/audit?type=${auditType}`, {
      state: {
        editData: auditData,
      },
    });
  };

  return (
    <div className="page-shell page-shell--error">
      <Header />

      <main className="page-shell__content">
        <div className="error-page">
          <div className="error-page__content">
            <h1 className="error-page__code">
              {getDisplayCode(code)}
            </h1>

            <h2 className="error-page__title">
              {title}
            </h2>

            <p className="error-page__description">
              {message}
            </p>

            <div className="error-page__actions">
              <Button onClick={handleRetry}>
                Try Again
              </Button>

              <Button
                variant="outline"
                onClick={handleEdit}
              >
                Edit Details
              </Button>
            </div>
          </div>

          <div className="error-page__glow" />
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ErrorPage;